export function computeDealDiscount(services, deal) {
  const percent = Number(deal?.discountPercent ?? deal?.discount_percent ?? 0)
  const serviceIds = deal?.serviceIds || deal?.service_ids || []
  if (!percent || !Array.isArray(services) || !Array.isArray(serviceIds) || serviceIds.length === 0) {
    return 0
  }

  const ids = new Set(serviceIds)
  const eligible = services.reduce((sum, service) => {
    if (!ids.has(service?.id)) return sum
    const price = parseFloat(service.price ?? service.price_from ?? 0)
    return sum + (Number.isFinite(price) ? price : 0)
  }, 0)

  return Math.round(eligible * (percent / 100) * 100) / 100
}

export function computeDealTotals(services, deal, taxRate = 0) {
  const subtotal = (services || []).reduce((sum, service) => {
    const price = parseFloat(service.price ?? service.price_from ?? 0)
    return sum + (Number.isFinite(price) ? price : 0)
  }, 0)
  const discount = computeDealDiscount(services, deal)
  const afterDiscount = Math.max(subtotal - discount, 0)
  const tax = afterDiscount * (Number(taxRate) || 0)
  return {
    subtotal,
    discount,
    tax,
    total: afterDiscount + tax,
  }
}
